"use strict";

jQuery.noConflict();
jQuery(document).ready(function ($) {
  $.fn.offers = function (options) {
    var loader = $('#js-loader');
    var loadMoreButton = $('.js-load-more');
    var offersContainer = $('#js-offers');
    var current_page = 1;
    var lang = offersContainer.data('lang');
    var that = this;
    var lengthOffers = 0;

    function getOffers(noReplace) {
      $.ajax({
        url: "/wp-json/wp/v2/socitec_offers",
        type: 'GET',
        data: {
          per_page: '6',
          page: current_page,
          lang: lang
        },
        beforeSend: function beforeSend() {
          loadMoreButton.addClass('d-none');
          loader.removeClass('d-none');
        },
        complete: function complete() {
          loadMoreButton.removeClass('d-none');
          loader.addClass('d-none');
        }
      }).done(function (res, textStatus, jqXHR) {
        var resLength = jqXHR.getResponseHeader('x-wp-total');
        loader.remove();
        lengthOffers += res.length;

        if (resLength <= 6 || lengthOffers == resLength) {
          loadMoreButton.remove();
        }

        if (res.length == 0) {
          $('#js-text').removeClass('d-none');
        } else {
          $('#js-text').addClass('d-none');
        }

        if (noReplace) {
          that.empty();
        }

        $.each(res, function (i, item) {
          var _acf$card_description;

          var acf = item.acf;
          var card = "<li class=\"col-sm-4 mbg\">\n              <article class=\"bg-third card-offer relative\">\n                <h2>\n                  <a href=\"".concat(item.link, "\" class=\"stretched-link\">").concat(item.title.rendered, "</a>\n                </h2>\n                <div>\n                <p> \n                ").concat((_acf$card_description = acf.card_description) !== null && _acf$card_description !== void 0 ? _acf$card_description : '', "\n                </p>\n                </div>\n                <a class=\"btn is-primary btn-icon\">").concat(lang == 'en' ? 'Discover' : 'Découvrir', " </a>\n              </article>\n            </li>");
          that.append(card);
        });
      });
    }

    if ($(this).length) {
      getOffers(true);
      loadMoreButton.click(function () {
        current_page++;
        getOffers(false);
      });
    }
  };
}(jQuery));
jQuery(document).ready(function ($) {
  $('#js-offers').offers();
});